module.exports = __webpack_public_path__ + "img/5L.3efdfd14.png";